export type Status = 'attended' | 'not attended' | 'registered';
export const StatusTypes: Status[] = ['attended', 'not attended', 'registered'];
